import { Component, EventEmitter, Input, Output } from "@angular/core"
import { GradeBand } from "../../../models/gradeBand.model"

@Component({
    selector: "app-grades-dropdown",
    templateUrl: "./grades-dropdown.component.html",
    styleUrls: ["./grades-dropdown.component.scss"],
})
export class GradesDropdownComponent {
    @Input()
    grades

    @Output()
    gradeSelected = new EventEmitter<string[]>()

    @Output()
    toggleGradePanel = new EventEmitter<string>()

    isGradesPanelOpened = false

    public toggleGradesPanel() {
        this.isGradesPanelOpened = !this.isGradesPanelOpened
        this.toggleGradePanel.emit("grade")
    }

    public onGradeSelected(gradeBand: GradeBand) {
        this.isGradesPanelOpened = false
        this.gradeSelected.emit([`/grades/${gradeBand.uri}/`])
    }
}
